export const SUPPORTED_LANGUAGES = {
  en: 'English',
  de: 'Deutsch',
  ja: '日本語',
} as const;

export interface LanguageOption {
  code: SupportedLanguageCode;
  name: string;
}

export type SupportedLanguageCode = keyof typeof SUPPORTED_LANGUAGES;

export const SUPPORTED_LANGUAGE_CODES: SupportedLanguageCode[] = Object.keys(
  SUPPORTED_LANGUAGES
) as SupportedLanguageCode[];

export const DEFAULT_LANGUAGE: SupportedLanguageCode = 'en';

export const DEFAULT_COUNTRY = 'US';

export const languageToLocaleMap: Record<SupportedLanguageCode, string> = {
  en: 'en-US',
  de: 'de-DE',
  ja: 'ja-JP',
};

export function isSupportedLanguageCode(code: string): code is SupportedLanguageCode {
  return Object.hasOwn(languageToLocaleMap, code);
}

export function getLocaleForLanguage(languageCode: string, separator: '-' | '_' = '-'): string {
  if (isSupportedLanguageCode(languageCode)) {
    const locale = languageToLocaleMap[languageCode];
    return separator === '_' ? locale.replace('-', '_') : locale;
  }

  const fallback = languageToLocaleMap[DEFAULT_LANGUAGE];
  return separator === '_' ? fallback.replace('-', '_') : fallback;
}

export interface LanguageChangeEvent {
  lang: SupportedLanguageCode;
  locale: string;
  timestamp: number;
}
